<template>
  <div class="contact" >
    <b-container class="page-container">
      <b-row>
        <b-col md="1"></b-col>
        <h1 class="title" style="padding-left: 10px">Contact</h1>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <b-breadcrumb :items="items"/>
      </b-row>
      <hr>
      <br>
      <br>
       <b-row>
        <b-col md="1"></b-col>
        <h4 class="text-left">If you have any questions, feel free to email donahoec@finitegames.com</h4>
      </b-row>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
    </b-container>
  </div>
</template>
<script>
export default {
  name: 'contact',
  data () {
    return {
      items: [
        {text: 'Home', to: '/'},
        {text: 'Contact', active: true}
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue